import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { updateFingerPrint } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function resetFingerPrint(accountId: number): Promise<TResult> {
  const response = await fetch(updateFingerPrint(accountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StausCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
};

type TSnapshot = unknown;

function useUpdateFingerPrint(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ accountId }: TVariables) => {
    const postResult = await resetFingerPrint(accountId);
    if (postResult.StatusCode === 200) {
      queryClient.invalidateQueries(['get_ftp_settings', accountId]);
      return postResult;
    } else if (postResult.Errors[0].Message) throw postResult;
    return postResult;
  });
}

export { useUpdateFingerPrint };
